module.exports = __webpack_public_path__ + "img/image49.17d8a375.jpg";